module.exports = fox => {
	const _phrases = {
		en: {
			ago: 'ago',
			now: 'just now',
			minuteAgo: '1 minute %a',
			minutesAgo: '%d minutes %a',
			hourAgo: '1 hour %a',
			hoursAgo: '%d hours %a',
			yesterday: 'yesterday',
			today: 'today',
			daysAgo: '%d days %a',
			weekAgo: '1 week %a',
			weeksAgo: '%d weeks %a',
			monthAgo: '1 month %a',
			monthsAgo: '%d months %a',
			yearAgo: '1 year %a',
			yearsAgo: '%d years %a',
			months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
			weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
			weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			weekdaysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
		},
		es: {
			ago: 'hace',
			now: 'ahora',
			minuteAgo: '%a 1 minuto',
			minutesAgo: '%a %d minutos',
			hourAgo: '%a 1 hora',
			hoursAgo: '%a %d horas',
			yesterday: 'ayer',
			today: 'hoy',
			daysAgo: '%a %d días',
			weekAgo: '%a 1 semana',
			weeksAgo: '%a %d semanas',
			monthAgo: '%a un mes',
			monthsAgo: '%a %d meses',
			yearAgo: '%a 1 año',
			yearsAgo: '%a %d años',
			months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
			monthsShort: ['Ene', 'Feb', 'Marzo', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'],
			weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
			weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
			weekdaysMin: ['D','L','M','X','J','V','S'],
		},
		de: {
			ago: 'vor',
			now: 'jetzt',
			minuteAgo: '%a 1 Minute',
			minutesAgo: '%a %d Minuten',
			hourAgo: '%a 1 Stunde',
			hoursAgo: '%a %d Stunden',
			yesterday: 'gestern',
			today: 'heute',
			daysAgo: '%a %d Tagen',
			weekAgo: '%a 1 Woche',
			weeksAgo: '%a %d Wochen',
			monthAgo: '%a 1 Monat',
			monthsAgo: '%a %d Monaten',
			yearAgo: '%a 1 Jahr',
			yearsAgo: '%a %d Jahren',
			months: ['Januar', 'Februar', 'Marz', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
			monthsShort: ['Jan', 'Feb', 'Marz', 'Apr', 'Mai', 'Juni', 'Juli', 'Aug', 'Sept', 'Okt', 'Nov', 'Dez'],
			weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Sonnabend'],
			weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
			weekdaysMin: ['So','Mo','Di','Mi','Do','Fr','Sa'],
		},
		ru: {
			ago: 'назад',
			now: 'только что',
			minuteAgo: '1 минуту %a',
			minutesAgo: ['%d минута %a', '%d минуты %a', '%d минут %a'],
			hourAgo: '1 час  %a',
			hoursAgo: ['%d час %a', '%d часа %a', '%d часов %a'],
			yesterday: 'вчера',
			today: 'сегодня',
			daysAgo: ['%d день %a', '%d дня %a', '%d дней %a'],
			weekAgo: '1 неделю %a',
			weeksAgo: ['%d неделю %a', '%d недели %a', '%d недель %a'],
			monthAgo: '1 месяц %a',
			monthsAgo: ['%d месяц %a', '%d месяца %a', '%d месяцев %a'],
			yearAgo: '1 год %a',
			yearsAgo: ['%d год %a', '%d года %a', '%d лет %a'],
			months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
			monthsShort: ['Янв', 'Февр', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сент', 'Окт', 'Нояб', 'Дек'],
			weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
			weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
			weekdaysMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
		},
		ar: {
			ago: 'قبل',
			now: 'الان',
			minuteAgo: '١ دقيقى %a',
			minutesAgo: '%d دقيقة %a',
			hourAgo: '١ ساعة %a',
			hoursAgo: '%d ساعات %a',
			yesterday: 'بالامس',
			today: 'اليوم',
			daysAgo: '%d ايام %a',
			weekAgo: '1 اسبوع %a',
			weeksAgo: '%d اسابيع %a',
			monthAgo: '1 شهر %a',
			monthsAgo: '%d اشهر %a',
			yearAgo: '1 سنة %a',
			yearsAgo: '%d سنوات %a',
			months: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
			monthsShort: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
			weekdays: ['الاحد', 'الاثنين', 'الثلاثاء', 'الاربعاء', 'الخميس', 'الجمعة', 'السبت'],
			weekdaysShort: ['الاحد', 'الاثنين', 'الثلاثاء', 'الاربعاء', 'الخميس', 'الجمعة', 'السبت'],
			weekdaysMin: ['احد', 'اثنين', 'ثلاثاء', 'اربعاء', 'خميس', 'جمعة', 'سبت'],
		},
		pt: {
			ago: 'ago',
			now: 'just now',
			minuteAgo: '1 minute %a',
			minutesAgo: '%d minutes %a',
			hourAgo: '1 hour %a',
			hoursAgo: '%d hours %a',
			yesterday: 'yesterday',
			today: 'today',
			daysAgo: '%d days %a',
			weekAgo: '1 week %a',
			weeksAgo: '%d weeks %a',
			monthAgo: '1 month %a',
			monthsAgo: '%d months %a',
			yearAgo: '1 year %a',
			yearsAgo: '%d years %a',
			months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
			weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
			weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			weekdaysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
		},
		fr: {
			ago: 'il y a',
			now: 'maintenant',
			minuteAgo: '%a 1 minute',
			minutesAgo: '%a %d minutes',
			hourAgo: '%a 1 heure',
			hoursAgo: '%a %d heures',
			yesterday: 'hier',
			today: 'aujourd\'hui',
			daysAgo: '%a %d jours',
			weekAgo: '%a 1 semaine',
			weeksAgo: '%a %d semaines',
			monthAgo: '%a 1 mois',
			monthsAgo: '%a %d mois',
			yearAgo: '%a 1 année',
			yearsAgo: '%a %d années',
			months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
			monthsShort: ['Janv', 'Févr', 'Mars', 'Avr', 'Mai', 'Juin', 'Juill', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
			weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
			weekdaysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
			weekdaysMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
		},
		jp: {
			ago: '前',
			now: '今すぐ',
			minuteAgo: '1分%a',
			minutesAgo: '%d分%a',
			hourAgo: '1時間%a',
			hoursAgo: '%d時間%a',
			yesterday: '昨日',
			today: '今日',
			daysAgo: '%d日%a',
			weekAgo: '1週間%a',
			weeksAgo: '%d週間%a',
			monthAgo: '1ヶ月%a',
			monthsAgo: '%dヶ月%a',
			yearAgo: '1年%a',
			yearsAgo: '%d年%a',
			months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
			monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
			weekdays: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
			weekdaysShort: ['日曜', '月曜', '火曜', '水曜', '木曜', '金曜', '土曜'],
			weekdaysMin: ['日', '月', '火', '水', '木', '金', '土'],
		},
	};
	return {
		delay(delay = 100) {
			return new fox.Promise(resolve => {
				setTimeout(resolve, delay);
			});
		},

		getLang() {
			let lang = 'en';
			if (!!fox && !!fox.i18n) {
				lang = fox.i18n.getISOLang();
			}
			return lang;
		},

		numpfRu(val) {
			const n10 = val % 10;
			if ( (n10 === 1) && ( (val === 1) || (val > 20) ) ) {
				return 0;
			} else if ( (n10 > 1) && (n10 < 5) && ( (val > 20) || (val < 10) ) ) {
				return 1;
			}
			return 2;
		},

		getPhrase(alias, val) {
			val = typeof val !== 'undefined' ? val.toString() : false;
			const lang = this.getLang();
			const phrases = _phrases[lang];

			if (typeof phrases[alias] === 'function') {
				return phrases[alias](val);
			} else if (typeof phrases[alias] === 'object' && !!val) {
				return phrases[alias][val];
			}

			return phrases[alias];
		},

		getPhraseAgo(alias, val) {
			const valString = !!val ? val.toString() : '';
			const phrase = this.getPhrase(alias, this.numpfRu(val));
			const ago = this.getPhrase('ago');
			return valString !== ''
				? phrase.replace('%d', valString).replace('%a', ago)
				: phrase.replace('%a', ago);
		},

		daysInMonth(month, year) {
			const date = new Date();
			year = !!year ? date.getFullYear() : year;
			month = !!month ? date.getMonth() : month;
			return 33 - new Date(year, month, 33).getDate();
		},
		
		getPeriodArray(type) {
			return this.getPhrase(type);
		},

		dateAgo(obj) {
			if (!obj) return '';
			const date = new Date(obj);
			const dim = this.daysInMonth(date.getMonth(), date.getFullYear());
			const diy = date.getFullYear() % 4 === 0 ? 366 : 365;
			const now = new Date().getTime();

			const diff = (now - date.getTime()) / 1000;
			const dayDiff = Math.floor(diff / 86400);

			if (isNaN(dayDiff) || dayDiff < 0) {
				return '';
			}

			d =  diff < 60 && this.getPhraseAgo('now', null) ||
				diff < 120 && this.getPhraseAgo('minuteAgo', null) ||
				diff < 3600 && this.getPhraseAgo('minutesAgo', Math.floor( diff / 60 )) ||
				diff < 7200 && this.getPhraseAgo('hourAgo', null) ||
				diff < 86400 && this.getPhraseAgo('hoursAgo', Math.floor( diff / 3600 )) ||
				dayDiff === 1 && this.getPhraseAgo('yesterday', null) ||
				dayDiff < 7 && this.getPhraseAgo('daysAgo', dayDiff) ||
				dayDiff === 7 && this.getPhraseAgo('weekAgo', null) ||
				dayDiff < dim && this.getPhraseAgo('weeksAgo', Math.floor( dayDiff / 7 )) ||
				dayDiff === dim && this.getPhraseAgo('monthAgo', null) ||
				dayDiff < diy && this.getPhraseAgo('monthsAgo', Math.floor( dayDiff / dim )) ||
				dayDiff === diy && this.getPhraseAgo('yearAgo', null) ||
				this.getPhraseAgo('yearsAgo', Math.floor( dayDiff / diy ));
			return d;
		},

		dateFormat(format, timestamp) {
			if (!timestamp) return '';
			const date = fox.utils.resolveDate(timestamp);

			function pad(number) {
				return number.toString().replace(/^([0-9])$/, '0$1');
			}

			const hours = date.getHours(),
					hours12h = (hours % 12) > 0 && (hours % 12) || 12,
					day = date.getDay(),
					dayOfMonth = date.getDate(),
					month = date.getMonth(),
					fullYear = date.getFullYear();

			// list all format keys
			const replacements = {
				// Day
				'a': this.getPhrase('weekdaysShort', day), // Short weekday, like 'Mon'
				'A': this.getPhrase('weekdays', day), // Long weekday, like 'Monday'
				'd': pad(dayOfMonth), // Two digit day of the month, 01 to 31
				'e': dayOfMonth, // Day of the month, 1 through 31
				// Week (none implemented)
				// Month
				'b': this.getPhrase('monthsShort', month), // Short month, like 'Jan'
				'B': this.getPhrase('months', month), // Long month, like 'January'
				'm': pad(month + 1), // Two digit month number, 01 through 12
				// Year
				'y': fullYear.toString().substr(2, 2), // Two digits year, like 09 for 2009
				'Y': fullYear, // Four digits year, like 2009
				// Time
				'H': pad(hours), // Two digits hours in 24h format, 00 through 23
				'I': pad(hours12h), // Two digits hours in 12h format, 00 through 11
				'l': hours12h, // Hours in 12h format, 1 through 11
				'M': pad(date.getMinutes()), // Two digits minutes, 00 through 59
				'p': hours < 12 ? 'AM' : 'PM', // Upper case AM or PM
				'P': hours < 12 ? 'am' : 'pm', // Lower case AM or PM
				'S': pad(date.getSeconds()), // Two digits seconds, 00 through  59
			};

			// do the replaces
			for (const key in replacements) {
				format = format.replace('%' + key, replacements[key]);
			}

			return format;
		}
	}
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/utils/utils.es.js